import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { useControlledInputs } from '../../common/hooks';
import Button from '../Button';
import { nfn } from '../../common';
import Icon from '../Icon';
import success from './images/success.svg';
import error from './images/error.svg';
import loading from './images/loading.svg';

const mapDefaultToValue = v => ({ name: v });
const mapValuetoValue = e => e.target.files[0];

/**
 * 文件上传模块
 */
export default function FileUpload({
  defaultValue,
  onChange,
  hasError,
  className,
  style,
  status,
  // onSubmit,
  mini,
  btnTip = '上传文件',
  accept
}) {
  const inputRef = useRef(null);
  const { value, handleChange } = useControlledInputs({
    defaultValue,
    onChange,
    mapDefaultToValue,
    mapValuetoValue
  });

  const selectFiles = () => {
    inputRef.current.click();
  };

  const classes = classNames('file-upload', className);
  const inputClasses = classNames('input file-name', {
    active: value && value.name,
    error: hasError,
    mini: mini
  });
  const handleValue = value => {
    if (!value) {
      return '';
    }
    if (typeof value?.name === 'object') {
      if (value.name?.name) {
        return value.name.name;
      }
      return '';
    } else {
      if (value.name) {
        return value.name;
      }
      return '';
    }
    return value;
  };
  return (
    <div className={classes} style={style}>
      <div className="file">
        <input
          type="file"
          ref={inputRef}
          onChange={handleChange}
          className="file-hide"
          accept={accept}
        />
        <div className={inputClasses} onClick={selectFiles}>
          {handleValue(value)}
        </div>
        <Button
          type="primary"
          className="file-upload-button"
          onClick={selectFiles}
          mini
        >
          {btnTip}
        </Button>
      </div>
      <div className="file-status">
        {status === 'success' && (
          <span className="file-success icon-box">
            <Icon link={success}></Icon>
            文件上传成功
          </span>
        )}
        {status === 'loading' && (
          <span className="file-loading icon-box">
            <Icon link={loading}></Icon>
            文件上传中...
          </span>
        )}
        {status === 'error' && (
          <span className="file-error icon-box">
            <Icon link={error}></Icon>
            文件上传失败
          </span>
        )}
      </div>
    </div>
  );
}

FileUpload.defaultProps = {
  onChange: nfn,
  btnTip: '上传文件'
};
FileUpload.propTypes = {
  /** 事件回调 */
  onChange: PropTypes.func,
  /** 默认值 */
  defaultValue: PropTypes.any,
  /** 是否Error, 自带error样式 */
  hasError: PropTypes.bool,
  /**上传状态 success、loading、error*/
  status: PropTypes.string,
  /**上传文件到服务器 */
  onSubmit: PropTypes.func,
  /**按钮文字 */
  btnTip: PropTypes.string
};
